import { faArrowLeft } from '@fortawesome/pro-solid-svg-icons';
import styled from 'styled-components';

import { IconButton } from '@sorare/core/src/atoms/buttons/IconButton';
import { Horizontal } from '@sorare/core/src/atoms/layout/flex';

import { ProgressBar } from './ProgressBar';

const Root = styled(Horizontal)`
  position: relative;
  width: 100%;
`;
const ProgressBarsWrapper = styled.div`
  width: 100%;
  display: grid;
  grid-template-columns: 10fr 1fr 1fr;
  column-gap: var(--unit);
`;

const progressToTemplateColumn = (progress: number, nextProgress: number) => {
  if (progress === 0 || (progress === 100 && nextProgress !== 0)) {
    return '1fr';
  }
  return '10fr';
};

type Props = { noBackButton?: boolean; onBack?: () => void; progress: number };
export const MarketGuidanceLayoutHeader = ({
  noBackButton,
  onBack,
  progress,
}: Props) => {
  const progresses = [
    Math.min(Math.max(progress * (1 / 0.4), 0), 100),
    Math.min(Math.max((progress - 40) * (1 / 0.4), 0), 100),
    Math.min(Math.max((progress - 80) * (1 / 0.2), 0), 100),
  ];

  return (
    <Root>
      {!noBackButton && (
        <IconButton onClick={onBack} icon={faArrowLeft} color="quaternary" />
      )}
      <ProgressBarsWrapper
        style={{
          gridTemplateColumns: progresses
            .map((p, i) => progressToTemplateColumn(p, progresses[i + 1] || 0))
            .join(' '),
        }}
      >
        {progresses.map((p, i) => (
          // eslint-disable-next-line react/no-array-index-key
          <ProgressBar key={i} progress={p} />
        ))}
      </ProgressBarsWrapper>
    </Root>
  );
};
